<template>
    <div class="table-responsive">
        <div class="d-flex justify-content-end align-items-center mb-3">
            <div class="d-flex align-items-center col-lg-3 col-md-3 col-xs-6">
                <label class="mb-0 mr-2">Channel: </label>
                <b-select v-model="filter.source" class="form-control">
                    <option :value="null">All</option>
                    <option v-if="onlinePharmacyEnabled" :value="2">
                        Online Pharmacy
                    </option>
                    <option v-if="petCareEnabled" :value="1">PetCare</option>
                </b-select>
            </div>
            <div class="d-flex align-items-center col-lg-2 col-md-3 col-xs-6">
                <label class="mb-0 mr-2">Status: </label>
                <b-select
                    v-model="filter.status"
                    class="form-control"
                    @change="getList()"
                >
                    <option :value="null">All</option>
                    <option :value="0">Pending</option>
                    <option :value="1">Approved</option>
                    <option :value="2">Denied</option>
                    <!-- only applicable for channel All & PetCare -->
                    <option v-if="filter.source != 2" :value="3">
                        Completed
                    </option>
                </b-select>
            </div>
        </div>
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list" id="table-notes">
            <b-thead>
                <b-tr>
                    <b-th>Item:</b-th>
                    <b-th class="text-nowrap">
                        <sorting
                            :order-by="sortBy.date"
                            text="Date/Time:"
                            @sorting="orderBy => sortList(orderBy, 'date')"
                        >
                        </sorting>
                    </b-th>
                    <b-th>Client:</b-th>
                    <b-th class="text-nowrap">
                        <sorting
                            :order-by="sortBy.patient"
                            text="Patient:"
                            @sorting="orderBy => sortList(orderBy, 'patient')"
                        >
                        </sorting>
                    </b-th>
                    <b-th>Channel:</b-th>
                    <b-th class="text-nowrap">Filled By:</b-th>
                    <b-th class="text-nowrap">Created By:</b-th>
                    <b-th>Status:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody v-if="list.length === 0">
                <b-tr>
                    <td colspan="12">
                        <i>No records available</i>
                    </td>
                </b-tr>
            </b-tbody>
            <b-tbody>
                <tr v-for="(item, i) in list" :key="i">
                    <b-td>
                        <input type="hidden" name="id" :value="item.id" />
                        <strong v-if="item.item">
                            {{ item.item.name }}
                        </strong>
                    </b-td>
                    <b-td>{{ displayDate(item.request_date) }}</b-td>
                    <b-td>
                        <client-name
                            v-if="item.client"
                            :client="item.client"
                            :text="item.client.display_name"
                        />
                    </b-td>
                    <b-td>
                        <patient-name
                            v-if="item.patient"
                            :use-router="USE_PATIENT_MODULE_VUE"
                            :patient="item.patient"
                            :showTab="{
                                tabName: 'tabHistory',
                                dropdown: HISTORY.VIEWS.REFILL_REQUEST,
                                status: getStatusLabel(item, true)
                            }"
                        />
                    </b-td>
                    <b-td>{{ item.channel }}</b-td>
                    <b-td>{{ item.filled_by }}</b-td>
                    <b-td>{{ item.create_by }}</b-td>
                    <b-td><span v-html="getStatusLabel(item)"></span></b-td>
                    <b-td class="text-right small text-nowrap">
                        <span
                            v-if="
                                (item.status == PENDING_STATUS && isProvider) ||
                                (item.status == PENDING_STATUS &&
                                    item.channel.toLowerCase() == VETSOURCE)
                            "
                            @click="approveRequest(item)"
                            class="cursor-pointer"
                        >
                            Approve
                        </span>
                        <span
                            v-if="
                                (item.status == PENDING_STATUS && isProvider) ||
                                (item.status == PENDING_STATUS &&
                                    item.channel.toLowerCase() == VETSOURCE)
                            "
                        >
                            |
                        </span>
                        <span
                            v-if="
                                (item.status == PENDING_STATUS && isProvider) ||
                                (item.status == PENDING_STATUS &&
                                    item.channel.toLowerCase() == VETSOURCE)
                            "
                            @click="denyRequest(item)"
                            class="cursor-pointer"
                        >
                            Deny
                        </span>
                        <span
                            v-if="
                                (item.status == PENDING_STATUS && isProvider) ||
                                (item.status == PENDING_STATUS &&
                                    item.channel.toLowerCase() == VETSOURCE)
                            "
                        >
                            |
                        </span>
                        <span
                            v-if="
                                item.channel.toLowerCase() == PETCARE &&
                                item.status == APPROVE_STATUS &&
                                !item.completed_at &&
                                isProvider
                            "
                            @click="completeRefillRequest(item)"
                            class="cursor-pointer"
                        >
                            Complete
                        </span>
                        <span
                            v-if="
                                item.channel.toLowerCase() == PETCARE &&
                                item.status == APPROVE_STATUS &&
                                !item.completed_at &&
                                isProvider
                            "
                        >
                            |
                        </span>
                        <span
                            @click="viewItemDetail(item)"
                            class="cursor-pointer"
                        >
                            View
                        </span>
                    </b-td>
                </tr>
            </b-tbody>
        </b-table-simple>
        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getList"
        />

        <modal-record ref="modalRecord" @onSuccess="onSuccessAction" />

        <modal-approve-request
            ref="modalApproveRequest"
            @onSuccess="onSuccessAction"
        />
        <modal-deny-request
            ref="modalDenyRequest"
            @onSuccess="onSuccessAction"
        />
        <modal-detail-request ref="modalDetailRequest" />

        <modal-approve-reject-request-refill
            ref="modalApproveRejectRequestRefill"
            @reload="getList"
            @approved="onApprovedRefillRequest"
        />
    </div>
</template>
<script>
import Records from "@/services/records";
import History from "@/services/patient-history";
import Loader from "@/components/elements/loader-list";
import ModalRecord from "@/module/commons/record/create-update";
import ClientName from "@/components/commons/client-name";
import PatientName from "@/components/commons/patient-name";
import HISTORY from "@/constants/history";
import EXTENSIONS from "@/constants/extensions";
import ProviderMixin from "@/mixins/provider";
import RxRequestMixin from "@/mixins/rx-request";
import { isObject } from "lodash";

export default {
    mixins: [ProviderMixin, RxRequestMixin],
    components: {
        Loader,
        ModalRecord,
        ClientName,
        PatientName,
        Sorting: () => import("@/module/commons/sorting.vue"),
        ModalApproveRejectRequestRefill: () =>
            import(
                "@/components/refill-requests/approve-reject-request-refill-modal"
            ),
        ModalDetailRequest: () =>
            import(
                "@/module/patient/dashboard/rx-request/modal-detail-request.vue"
            ),
        ModalApproveRequest: () =>
            import(
                "@/module/patient/dashboard/rx-request/modal-approve-request.vue"
            ),
        ModalDenyRequest: () =>
            import(
                "@/module/patient/dashboard/rx-request/modal-deny-request.vue"
            )
    },
    props: {
        category: {
            type: Number
        }
    },
    computed: {
        onlinePharmacyEnabled() {
            return (
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_VETSOURCE) ||
                this._isExtensionEnabled(EXTENSIONS.CODE.CODE_VETCOVE_ONLINE)
            );
        },
        petCareEnabled() {
            return this._isExtensionEnabled(
                EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
            );
        }
    },
    watch: {
        "filter.source": {
            handler(newData, oldData) {
                this.filter.status = null;
                this.getList();
            }
        }
    },
    data() {
        return {
            list: [],
            isLoading: false,
            showTheToast: false,
            meta: null,
            filter: {
                source: null,
                status: null
            },
            sortBy: {
                date: null,
                patient: null
            },
            isRowDragging: false,
            selectedRequest: {},
            VETSOURCE: "vetsource",
            PETCARE: "petcare",
            HISTORY: HISTORY
        };
    },
    mounted() {
        if (this.category != null) {
            this.filter.status = this.category;
        }

        // if query TAB=REFILLREQUEST exist, display pending request list
        let query = this.$route.query;
        if (query && query.tab == "REFILLREQUEST") {
            this.filter.status = 0;
        }

        this.getProvider();
        this.getList();
    },
    methods: {
        getList(page) {
            this.isLoading = true;

            let params = { page: page ? page : 1 };

            if (this.filter.source) {
                params.channel = this.filter.source;
            }

            if (this.sortBy.date) {
                params.date = this.sortBy.date;
            }

            if (this.sortBy.patient) {
                params.patient_name = this.sortBy.patient;
            }

            if (this.filter.status != null) {
                params.status = this.filter.status;
            }

            if (this.filter.status == this.COMPLETED_STATUS) {
                params.status = this.APPROVE_STATUS;
                params.completed = true;
            }

            Records.getRxRequests(params)
                .then(response => {
                    if (response.code == 200) {
                        this.list = response.resource;
                        this.meta = response.meta;
                        this.isLoading = false;
                    } else {
                        throw "error";
                    }
                })
                .catch(error => {
                    this._message(
                        "Error : Unable to get refill request",
                        "danger"
                    );
                    this.isLoading = false;
                });
        },
        sortList(val, type) {
            if (type == "date") {
                this.sortBy.date = val;
            } else if (type == "patient") {
                this.sortBy.patient = val;
            }

            this.getList(this.meta.currentPage);
        },
        viewItemDetail(item) {
            this.$refs.modalDetailRequest.open(item);
        },
        displayDate(date) {
            return this._carbonDateTimeDisplay(date);
        },
        getDeliveryOption(deliveryOption) {
            if (isObject(deliveryOption)) {
                return deliveryOption.value;
            } else if (deliveryOption == 1) {
                return "Pickup";
            } else if (deliveryOption == 2) {
                return "Mail";
            } else {
                return "--";
            }
        },
        extractRequestParams(rec) {
            let mapChannel = {
                PETCARE: 1,
                VETSOURCE: 2
            };

            let key = rec?.channel ?? "";
            key = key.toUpperCase();
            let channel = mapChannel[key] ?? null;

            let vetSourceItemType = null;
            if (channel === 2) {
                vetSourceItemType = rec?.item_type;
            }

            return {
                ...rec,
                recordId: rec?.id,
                clientId: rec?.client_id,
                clientName: rec?.client?.display_name ?? rec?.client?.name,
                patientId: rec?.patient_id,
                patientName: rec?.patient?.display_name ?? rec?.patient?.name,
                itemId: rec?.item_id,
                itemName: rec?.item?.display_name ?? rec?.item?.name,
                denyReasons: rec?.denial_reasons,
                ptBreed: rec?.patient.breed_species,
                ptWeight: rec?.patient.weight,
                ptAge: rec?.patient.age,
                itemPackaging: rec?.item?.packaging,
                itemStrength: rec?.item?.strength,
                isClinicalRationaleRequired:
                    rec?.isClinicalRationaleRequired ?? false,
                clinicalRationales: rec?.clinicalRationales ?? [],
                channel,
                vetSourceItemType
            };
        },
        approveRequest(record) {
            if (record.channel.toLowerCase() == this.VETSOURCE) {
                let params = this.extractRequestParams(record);
                this.$refs.modalApproveRequest.open(params);
            } else {
                this.processRefillRequest(record, "APPROVE");
            }
        },
        denyRequest(record) {
            if (record.channel.toLowerCase() == this.VETSOURCE) {
                let params = this.extractRequestParams(record);
                this.$refs.modalDenyRequest.open(params);
            } else {
                this.processRefillRequest(record, "REJECT");
            }
        },
        processRefillRequest(record, mode) {
            const errorMessage = "Error: Unable to get refill request details";

            Records.getRecordRefillRequest(record.id)
                .then(response => {
                    if (response.message.code == 200) {
                        this.selectedRequest = response.resource;

                        if (this.selectedRequest.status == this.PENDING_STATUS)
                            this.$refs.modalApproveRejectRequestRefill.open(
                                this.selectedRequest,
                                mode
                            );
                    } else {
                        this._message(errorMessage, "danger");
                    }
                })
                .catch(error => {
                    this._message(errorMessage, "danger");
                    console.error(error);
                });
        },
        onApprovedRefillRequest() {
            this.getList();
            this.completeRefillRequest(this.selectedRequest);
        },
        async completeRefillRequest(request) {
            try {
                let recordResponse = await Records.getRecordRefillRequest(
                    request.id
                );

                if (
                    recordResponse &&
                    recordResponse.message &&
                    recordResponse.message.code != 200
                ) {
                    throw recordResponse.message.code;
                }

                let record = recordResponse.resource;

                let recordDetailsResponse = await History.getRecordDetails(
                    record.parent_record_id
                );

                if (
                    recordDetailsResponse &&
                    recordDetailsResponse.message &&
                    recordDetailsResponse.message.code != 200
                ) {
                    throw recordDetailsResponse.message.code;
                }

                let refillResponse = await Records.refillRecordDetails(
                    record.parent_record_id
                );

                this.$refs.modalRecord.open({
                    ...record,
                    clientID: request.client.id,
                    action: "refill",
                    module: this.MODULE.PATIENT,
                    record_resources: refillResponse
                });
            } catch (error) {
                this._message("Error: Unable to initiate refill", "danger");
            }
        },
        onSuccessAction() {
            this.$emit("reload-tab-count");
            this.getList();
        }
    }
};
</script>
